export default {
  categories1: state => state.categories1,
  categories2: state => state.categories2
}



// WEBPACK FOOTER //
// ./src/store/modules/category/getters.js